// PrivateRoute.js
import { useContext } from "react";
import { AuthContext } from "./auth/auth";
import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { loading, user } = useContext(AuthContext);

  let auth = { token: false };
  return user ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
